<template>
  <div class="picture_card-root">
    <ul class="images-list">
      <li class="image-item">
        <label class="upload-label" @click="() => {this.$refs.inputFileUp.click()}">
          <i class="el-icon-plus cover-up-icon"></i>
          <span class="btn-text">添加图片</span>
          <div v-show="showPercent"
               class="progress" @click.stop="()=>{}">
            <el-progress type="circle"
                         :width="progressSize"
                         :percentage="percent"></el-progress>
          </div>
        </label>
        <input
          type="file"
          ref="inputFileUp" 
          :multiple='multiple'
          @click="fileInputClick($event)"
          @change="coverImgChange($event)"
          style="display:none !important;"
        >
      </li>
      <li
        v-for="(item,index) in showList"
        :key="item.id"
        class="image-item"
      >
        <div class="item-content" :style="{backgroundImage: `url(${item.imageUrl})`}"></div>
        <i class="iconfont el-icon-close" @click="removeImg(index)"></i>
      </li>
    </ul>
  </div>
</template>

<script>
import { upImage } from "@/api/common/api";
import { correctStatus } from "@/assets/js/apiStatus";

export default {
  name: "PictureCard",
  props: {
    urlList: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    progressSize: {
      type: Number,
      required: false,
      default: 98
    },
  },
  data() {
    return {
      ltSize: {
        reg: 15,
        msg: "上传图片大小不能超过15MB"
      },
      ltFormat: {
        reg: /^.*\.(jpg|png|jpeg|gif)$/i,
        msg: "仅支持jpg,jpeg,png,gif格式的图片"
      },
      showList: [],
      percent: 0,
      showPercent: false,
    };
  },
  methods: {
    // 点击上传文件之后,清空type="file"输入框的值,防止选择上次选择那个文件时不触发input的change事件
    fileInputClick(event) {
      event.target.value = null;
    },
    coverImgChange(event) {
      const fileList = event.target.files;
      for (const file of fileList) {
        const isJPG_PNG = this.ltFormat.reg.test(file.name);
        const isLt5M = file.size / 1024 / 1024 <= this.ltSize.reg;
        if (!isLt5M) {
          this.$message.error(this.ltSize.msg);
        }
        if (!isJPG_PNG) {
          this.$message.error(this.ltFormat.msg);
        }
        if (!(isJPG_PNG && isLt5M)) {
          continue;
        }
        this.ajaxUp(file)
      }
    },
    ajaxUp(file) {
      // 调用后台上传图片的接口.
      const upParams = new FormData();
      upParams.append("image", file);
      upParams.append("filename", file.name);
      this.percent = 0;
      this.showPercent = true;
      upImage(upParams, this.progressFn).then(({ data }) => {
        if (data.status === correctStatus) {
          this.showList.push({
            imageUrl: window.URL.createObjectURL(file),
            imageName: file.name,
            imageSize: file.size,
            id: Date.now()
          });
          this.$emit("update:urlList", [
            ...this.urlList,
            { url: data.result.image_url }
          ]);
        }
        this.showPercent = false;
      });
    },
    progressFn(e) {
      this.percent = parseInt((e.loaded/e.total)*100);
    },
    removeImg(index) {
      this.showList.splice(index, 1);
      this.$emit("update:urlList", [
        ...this.urlList.slice(0, index),
        ...this.urlList.slice(index + 1)
      ]);
    },
    resetList() {
      this.showList.splice(0, this.showList.length);
    },
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'

.picture_card-root
  display block
  .images-list
    display flex
    width 100%
    flex-direction row
    flex-wrap wrap
    align-items center
    align-content flex-start
    padding-top 10px
    overflow hidden
    .image-item 
      position relative
      z-index 3
      width 150px
      height 170px
      margin-right 10px
      padding-bottom 20px
      .item-content 
        display block 
        height 100% 
        background-position center
        background-size cover
        background-repeat no-repeat 
        border-radius 3px
      .iconfont
        position absolute
        top 0
        right 0
        font-size 14px
        z-index 10
        line-height 1
        padding 2px
        background-color $color_suc
        border-radius 50%
        border 1px solid
        color $color_white
        transform translate(43%, -43%)
        cursor pointer
    .upload-label
      display flex
      flex-flow column
      justify-content center
      align-items center
      position relative
      text-align center
      background-color #f3f3f3
      border 1px solid #f3f3f3
      border-radius 2px
      cursor pointer
      height 100%
      color #8c939d
      & > .cover-up-icon
        font-size 30px
        margin-bottom 5px
        color #8c939d
      .progress
        width 100%
        height 100%
        display flex
        justify-content center
        align-items center
        position absolute
        top 0
        left 0
        z-index 100
        background-color $color_white
</style>


